import { useEffect, useState } from "react"
import "./missionList.css"
import {format, register} from "timeago.js"
import { MissionItem } from "./missionItem";

export default function MissionList({ mission, selectedMission, setSelectedMission, isMissionDragging, setMissionDragging }) {
  const [missionstate,setMissionstate] = useState("new")

  const de = require("timeago.js/lib/lang/de").default;
  register("de", de);

  useEffect(() => {
    if(mission.state === 0) {
      setMissionstate("new");
    } else if(mission.state === 1) {
      setMissionstate("sighted");
    } else if(mission.state === 2) {
      setMissionstate("inProgress");
    } else if(mission.state === 3) {
      setMissionstate("finished");
    }
  }, [mission.state]);

  return (
    <MissionItem 
      mission={mission} 
      selectedMission={selectedMission}
      setSelectedMission={setSelectedMission}
      isMissionDragging={isMissionDragging}
      setMissionDragging={setMissionDragging}
    />
  )
}
